import styled, { css } from 'styled-components';
import { Button, ButtonAppearance, Avatar, Heading } from '@bechtel/gds';

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}
export const FooterButtonStyled = styled(Button).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;

export const HeadingStyled = styled(Heading).attrs({
  size: '400',
  color: 'grey.1000',
})`
  padding-top: ${({ theme }) => theme.spacings[100]};
  padding-bottom: ${({ theme }) => theme.spacings[100]};
  white-space: nowrap;
`;
export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;
